import posthog from 'posthog-js'

// PostHog 初始化配置
export const initPostHog = () => {
  // 從環境變數讀取 API Key，如果沒有設定就使用預設值
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY || 'phc_CMmx9epWTmKEUq0IAW4AVgZ1B8Vvm35QTXmK1EhCJEb';
  const apiHost = process.env.REACT_APP_POSTHOG_API_HOST || 'https://us.i.posthog.com';
  
  posthog.init(apiKey, {
    api_host: apiHost,
    // 啟用自動事件收集
    autocapture: true,
    // 在開發環境中顯示更多調試資訊
    debug: process.env.NODE_ENV === 'development',
    loaded: () => {
      if (process.env.NODE_ENV === 'development') {
        console.log('PostHog 已初始化 (開發模式)')
        console.log('在開發模式下，所有事件都會正常發送到 PostHog')
      }
    }
  })
}

// 追蹤自定義事件的輔助函數
export const trackEvent = (eventName, properties = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('PostHog 事件:', eventName, properties)
  }
  posthog.capture(eventName, properties)
}

// 追蹤頁面瀏覽
export const trackPageView = (pageName) => {
  posthog.capture('page_view', {
    page: pageName,
    timestamp: new Date().toISOString()
  })
}

// 追蹤用戶屬性
export const identifyUser = (userId, properties = {}) => {
  posthog.identify(userId, properties)
}

export default posthog